import { createApi } from '@reduxjs/toolkit/query/react';

import { Stake, StakesResponse } from '@/slices/stakes/stakes.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

const stakesApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/enterprises',
  }),
  reducerPath: 'stakes',
  tagTypes: ['Stakes'],
  endpoints: (build) => ({
    getStakesFromTopicIds: build.query<
      Stake[],
      { enterpriseId: string; topicIds: string[] }
    >({
      query: ({ enterpriseId, topicIds }) => ({
        url: `/${enterpriseId}/stakes/from-topic-ids`,
        method: 'POST',
        data: {
          topicIds,
        },
      }),
      transformResponse: (response: StakesResponse) => response.stakes ?? [],
      providesTags: (_result, _error, { enterpriseId }) => [
        { type: 'Stakes', id: enterpriseId },
      ],
    }),
  }),
});

export default stakesApi;
